// @flow

import * as React from 'react';
import ReactHtmlParser from 'react-html-parser';
import { Button, Modal, Grid } from 'semantic-ui-react';
import LoadSVG from './LoadSVG';
import { Link } from 'react-router-dom';
import type { AcfFields } from '../types/personas';
import { getHelixBaseUrl } from '../helpers';

type Props = {
  acf: AcfFields,
  images: [
    {
      url: string,
      alt: string,
      title: string,
    },
  ],
  link: string,
  country: string,
};

class PersonaModal extends React.Component<Props> {
  render(): React.Node {
    const {
      personacommunityNumber,
      title,
      summaryExcerpt,
      excerptValue1,
      excerptValue2,
      excerptIcon1,
      excerptLabel1,
      color,
      excerptNumberOnLeft1,
      excerptNumberOnLeft2,
      excerptIcon2,
      excerptLabel2,
    } = this.props.acf;

    return (
      <React.Fragment>
        <Modal.Header>
          {ReactHtmlParser(personacommunityNumber + ' - ' + title)}
        </Modal.Header>
        <Modal.Content>
          <Grid columns={2} stackable={true}>
            <Grid.Column>
              <div className="persona-tile">
                <div className="persona-tile__number">
                  {personacommunityNumber}
                </div>
                <div className="persona-tile__name">
                  {ReactHtmlParser(title)}
                </div>
                <div className="persona-tile__content">
                  {(excerptValue1 || excerptValue2) && (
                    <div className="persona-tile__stats-container">
                      <span className="persona-tile-stat">
                        <span className="persona-tile-stat__icon">
                          {excerptIcon1 &&
                            excerptIcon1.image &&
                            excerptIcon1.image.url && (
                              <LoadSVG
                                src={excerptIcon1.image.url}
                                title={excerptLabel1}
                                alt={excerptLabel1}
                                colour={color}
                              />
                            )}
                        </span>
                        {excerptNumberOnLeft1 && (
                          <span className="persona-tile-stat__figure">
                            {excerptValue1} {excerptLabel1}
                          </span>
                        )}
                        {!excerptNumberOnLeft1 && (
                          <span className="persona-tile-stat__figure">
                            {excerptLabel1} {excerptValue1}
                          </span>
                        )}
                      </span>
                      <span className="persona-tile-stat">
                        <span className="persona-tile-stat__icon">
                          {excerptIcon2 &&
                            excerptIcon2.image &&
                            excerptIcon2.image.url && (
                              <LoadSVG
                                src={excerptIcon2.image.url}
                                title={excerptLabel2}
                                alt={excerptLabel2}
                                colour={color}
                              />
                            )}
                        </span>
                        {excerptNumberOnLeft2 && (
                          <span className="persona-tile-stat__figure">
                            {excerptValue2} {excerptLabel2}
                          </span>
                        )}
                        {!excerptNumberOnLeft2 && (
                          <span className="persona-tile-stat__figure">
                            {excerptLabel2} {excerptValue2}
                          </span>
                        )}
                      </span>
                    </div>
                  )}
                  <div className="persona-tile__text">
                    {ReactHtmlParser(summaryExcerpt)}
                  </div>
                  <div className="persona-tile__button-container">
                    <Button
                      as={Link}
                      target={'_blank'}
                      to={`//${getHelixBaseUrl(this.props.country)}/${this.props.link}`}
                      style={{ backgroundColor: color }}
                    >
                      Read More
                    </Button>
                  </div>
                </div>
              </div>
            </Grid.Column>
            <Grid.Column>
              {this.props.images ? (
                <div className="persona-images-grid">
                  {this.props.images.slice(0, 6).map((item, key) => (
                    <div key={key}>
                      <img src={item.url} alt={item.alt} title={item.title} />
                    </div>
                  ))}
                </div>
              ) : (
                ''
              )}
            </Grid.Column>
          </Grid>
        </Modal.Content>
      </React.Fragment>
    );
  }
}

export default PersonaModal;
